<template>
	<div>
		<tooltip label="Text" placement="right">
			<input
				class="form-control"
				v-autocomplete="autocomplete"
				v-model="data"
				placeholder="Text"
				@input="dataChanged"
			/>
		</tooltip>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: null,
				autocomplete: {},
				command_id: null,
				service_id: null,
			}
		},
		methods: {
			dataChanged() {
				if (this.$store.state.responseData) {
					this.$store.commit('setResponseDataProperty', {resp_text: this.data})
				} else {
					this.$router.push(`/services/${this.service_id}/commands/${this.command_id}/result/type`)
				}
			}
		},
		mounted() {
			this.autocomplete = Object.assign(this.autocomplete, clone(this.$store.state.autocomplete))
		},
		created() {
			console.log(this.$store.state.responseData.resp_text);

			this.data = this.$store.state.responseData.resp_text
			this.command_id = this.$route.params.command_id
			this.service_id = this.$route.params.service_id
		},
		computed: {
			//
		},
	}
</script>

<style lang="scss" scoped>
</style>
